import { StackCall } from '../../domain/TimelineSpan'
import * as React from 'react'
import { isCutOffPoint } from './StackTraceCutOffPoint'
import { DynamicallyInstrumentedFunction } from '../DynamicallyInstrumentedFunction'
import { dynamicallyInstrumentedFunctionDetailsFromStackTrace } from '../../redux/V2/DynamicallyInstrumentedFunction/DynamicallyInstrumentedFunctionState'
import { connect } from 'react-redux'
import { ApplicationState } from '../../redux/ApplicationState'
import { Col, Row } from '../../ui/grid'

interface OwnProps {
    stack: StackCall[]
}

interface StateProps {
    includesDynamicallyInstrumentedFunctions: boolean
}

type Props = OwnProps & StateProps

class TraceDetailsStacktraceComponent extends React.PureComponent<Props> {
    public render = () => (
        <Row>
            <Col>
                <small>Stack</small>
            </Col>
            <Col>
                <pre className="stacktrace">
                    <code>
                        {isCutOffPoint(`${this.props.stack[0].class}::${this.props.stack[0].function}`) ? (
                            <div>[calls in vendor code beyond this function were cut off]</div>
                        ) : null}
                        {this.props.stack.map((param, key) => (
                            <div className="stacktrace-row" key={key}>
                                {key > 0 ? (
                                    <div className="stacktrace-trackedFunction">
                                        {this.props.includesDynamicallyInstrumentedFunctions ? (
                                            <DynamicallyInstrumentedFunction
                                                details={dynamicallyInstrumentedFunctionDetailsFromStackTrace(param)}
                                            />
                                        ) : null}
                                    </div>
                                ) : null}
                                <>#{key} </>
                                {param.class ? <>{param.class}::</> : null}
                                {param.function}()
                            </div>
                        ))}
                    </code>
                </pre>
            </Col>
        </Row>
    )
}

export const TraceDetailsStacktrace = connect(
    (globalState: ApplicationState): StateProps => ({
        includesDynamicallyInstrumentedFunctions: globalState.tidewaysContext.application?.includesDynamicallyInstrumentedFunctions,
    }),
)(TraceDetailsStacktraceComponent)
